// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-image-shell.user-image {
  --image-shell-border-radius: var(--page-border-radius);
}

.user-name > app-text-shell {
  --text-shell-line-height: 20px;
  max-width: 50%;
}
.user-name > app-text-shell.text-loaded {
  max-width: unset;
}

.user-title > app-text-shell {
  --text-shell-line-height: 16px;
  max-width: 70%;
}
.user-title > app-text-shell.text-loaded {
  max-width: unset;
}

.user-membership > app-text-shell {
  --text-shell-line-color: rgba(var(--ion-color-secondary-rgb), 0.4);
  --text-shell-line-height: 14px;
  min-width: 30px;
}
.user-membership > app-text-shell.text-loaded {
  min-width: 0px;
}

.stat-value > app-text-shell {
  --text-shell-line-height: 18px;
  max-width: 50%;
  margin: 0px auto;
}
.stat-value > app-text-shell.text-loaded {
  max-width: unset;
  margin: initial;
}

.user-description > app-text-shell {
  --text-shell-line-height: 14px;
}

app-image-shell.friend-picture {
  --image-shell-border-radius: var(--page-border-radius);
}

.friend-name > app-text-shell {
  --text-shell-line-height: 14px;
}

app-image-shell.user-photo-image {
  --image-shell-border-radius: var(--page-border-radius);
}`, "",{"version":3,"sources":["webpack://./src/app/components/horizontal-list-sites/styles/user-profile.shell.scss"],"names":[],"mappings":"AAAA;EACE,sDAAA;AACF;;AAEA;EACE,8BAAA;EACA,cAAA;AACF;AACE;EACE,gBAAA;AACJ;;AAGA;EACE,8BAAA;EACA,cAAA;AAAF;AAEE;EACE,gBAAA;AAAJ;;AAIA;EACE,kEAAA;EACA,8BAAA;EACA,eAAA;AADF;AAGE;EACE,cAAA;AADJ;;AAKA;EACE,8BAAA;EACA,cAAA;EACA,gBAAA;AAFF;AAIE;EACE,gBAAA;EACA,eAAA;AAFJ;;AAMA;EACE,8BAAA;AAHF;;AAMA;EACE,sDAAA;AAHF;;AAMA;EACE,8BAAA;AAHF;;AAMA;EACE,sDAAA;AAHF","sourcesContent":["app-image-shell.user-image {\r\n  --image-shell-border-radius: var(--page-border-radius);\r\n}\r\n\r\n.user-name > app-text-shell {\r\n  --text-shell-line-height: 20px;\r\n  max-width: 50%;\r\n\r\n  &.text-loaded {\r\n    max-width: unset;\r\n  }\r\n}\r\n\r\n.user-title > app-text-shell {\r\n  --text-shell-line-height: 16px;\r\n  max-width: 70%;\r\n\r\n  &.text-loaded {\r\n    max-width: unset;\r\n  }\r\n}\r\n\r\n.user-membership > app-text-shell {\r\n  --text-shell-line-color: rgba(var(--ion-color-secondary-rgb), 0.4);\r\n  --text-shell-line-height: 14px;\r\n  min-width: 30px;\r\n\r\n  &.text-loaded {\r\n    min-width: 0px;\r\n  }\r\n}\r\n\r\n.stat-value > app-text-shell {\r\n  --text-shell-line-height: 18px;\r\n  max-width: 50%;\r\n  margin: 0px auto;\r\n\r\n  &.text-loaded {\r\n    max-width: unset;\r\n    margin: initial;\r\n  }\r\n}\r\n\r\n.user-description > app-text-shell {\r\n  --text-shell-line-height: 14px;\r\n}\r\n\r\napp-image-shell.friend-picture {\r\n  --image-shell-border-radius: var(--page-border-radius);\r\n}\r\n\r\n.friend-name > app-text-shell {\r\n  --text-shell-line-height: 14px;\r\n}\r\n\r\napp-image-shell.user-photo-image {\r\n  --image-shell-border-radius: var(--page-border-radius);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
